exports.engineTypes = [
  "Inline 3",
  "Inline 4",
  "Inline 5",
  "Inline 6",
  "V6",
  "V8",
  "V10",
  "V12",
  "V16",
  "W12",
  "W16",
  "Flat 4", //boxer 4
  "Flat 6", //boxer 6
  "rotary",
];

exports.years = Array.from(
  { length: new Date().getFullYear() - 1900 + 1 },
  (_, i) => 1900 + i,
);

exports.ownerships = Array.from({ length: 10 }, (_, i) => i + 1);

exports.fuelTypes = ["petrol", "diesel", "electric", "hybrid", "CNG", "LPG"];

exports.transmissions = ["manual", "automatic"];

exports.countryCodes = [
  { code: "+1", country: "USA/Canada", maxLength: 10 },
  { code: "+7", country: "Russia", maxLength: 10 },
  { code: "+20", country: "Egypt", maxLength: 10 },
  { code: "+27", country: "South Africa", maxLength: 9 },
  { code: "+30", country: "Greece", maxLength: 10 },
  { code: "+31", country: "Netherlands", maxLength: 9 },
  { code: "+32", country: "Belgium", maxLength: 9 },
  { code: "+33", country: "France", maxLength: 9 },
  { code: "+34", country: "Spain", maxLength: 9 },
  { code: "+36", country: "Hungary", maxLength: 9 },
  { code: "+39", country: "Italy", maxLength: 10 },
  { code: "+40", country: "Romania", maxLength: 9 },
  { code: "+41", country: "Switzerland", maxLength: 9 },
  { code: "+43", country: "Austria", maxLength: 10 },
  { code: "+44", country: "UK", maxLength: 10 },
  { code: "+45", country: "Denmark", maxLength: 8 },
  { code: "+46", country: "Sweden", maxLength: 9 },
  { code: "+47", country: "Norway", maxLength: 8 },
  { code: "+48", country: "Poland", maxLength: 9 },
  { code: "+49", country: "Germany", maxLength: 11 },
  { code: "+51", country: "Peru", maxLength: 9 },
  { code: "+52", country: "Mexico", maxLength: 10 },
  { code: "+54", country: "Argentina", maxLength: 10 },
  { code: "+55", country: "Brazil", maxLength: 11 },
  { code: "+56", country: "Chile", maxLength: 9 },
  { code: "+57", country: "Colombia", maxLength: 10 },
  { code: "+60", country: "Malaysia", maxLength: 10 },
  { code: "+61", country: "Australia", maxLength: 9 },
  { code: "+62", country: "Indonesia", maxLength: 11 },
  { code: "+63", country: "Philippines", maxLength: 10 },
  { code: "+64", country: "New Zealand", maxLength: 9 },
  { code: "+65", country: "Singapore", maxLength: 8 },
  { code: "+66", country: "Thailand", maxLength: 9 },
  { code: "+81", country: "Japan", maxLength: 10 },
  { code: "+82", country: "South Korea", maxLength: 10 },
  { code: "+84", country: "Vietnam", maxLength: 10 },
  { code: "+86", country: "China", maxLength: 11 },
  { code: "+90", country: "Turkey", maxLength: 10 },
  { code: "+91", country: "India", maxLength: 10 },
  { code: "+92", country: "Pakistan", maxLength: 10 },
  { code: "+93", country: "Afghanistan", maxLength: 9 },
  { code: "+94", country: "Sri Lanka", maxLength: 9 },
  { code: "+95", country: "Myanmar", maxLength: 9 },
  { code: "+98", country: "Iran", maxLength: 10 },
  { code: "+212", country: "Morocco", maxLength: 9 },
  { code: "+213", country: "Algeria", maxLength: 9 },
  { code: "+216", country: "Tunisia", maxLength: 8 },
  { code: "+218", country: "Libya", maxLength: 9 },
  { code: "+220", country: "Gambia", maxLength: 7 },
  { code: "+221", country: "Senegal", maxLength: 9 },
  { code: "+233", country: "Ghana", maxLength: 9 },
  { code: "+234", country: "Nigeria", maxLength: 10 },
  { code: "+254", country: "Kenya", maxLength: 9 },
  { code: "+255", country: "Tanzania", maxLength: 9 },
  { code: "+256", country: "Uganda", maxLength: 9 },
  { code: "+260", country: "Zambia", maxLength: 9 },
  { code: "+263", country: "Zimbabwe", maxLength: 9 },
  { code: "+351", country: "Portugal", maxLength: 9 },
  { code: "+353", country: "Ireland", maxLength: 9 },
  { code: "+354", country: "Iceland", maxLength: 7 },
  { code: "+358", country: "Finland", maxLength: 10 },
  { code: "+370", country: "Lithuania", maxLength: 8 },
  { code: "+371", country: "Latvia", maxLength: 8 },
  { code: "+372", country: "Estonia", maxLength: 8 },
  { code: "+380", country: "Ukraine", maxLength: 9 },
  { code: "+381", country: "Serbia", maxLength: 9 },
  { code: "+385", country: "Croatia", maxLength: 9 },
  { code: "+386", country: "Slovenia", maxLength: 8 },
  { code: "+420", country: "Czech Republic", maxLength: 9 },
  { code: "+421", country: "Slovakia", maxLength: 9 },
  { code: "+852", country: "Hong Kong", maxLength: 8 },
  { code: "+853", country: "Macau", maxLength: 8 },
  { code: "+880", country: "Bangladesh", maxLength: 10 },
  { code: "+886", country: "Taiwan", maxLength: 9 },
  { code: "+960", country: "Maldives", maxLength: 7 },
  { code: "+961", country: "Lebanon", maxLength: 8 },
  { code: "+962", country: "Jordan", maxLength: 9 },
  { code: "+963", country: "Syria", maxLength: 9 },
  { code: "+964", country: "Iraq", maxLength: 10 },
  { code: "+965", country: "Kuwait", maxLength: 8 },
  { code: "+966", country: "Saudi Arabia", maxLength: 9 },
  { code: "+967", country: "Yemen", maxLength: 9 },
  { code: "+968", country: "Oman", maxLength: 8 },
  { code: "+970", country: "Palestine", maxLength: 9 },
  { code: "+971", country: "UAE", maxLength: 9 },
  { code: "+972", country: "Israel", maxLength: 9 },
  { code: "+973", country: "Bahrain", maxLength: 8 },
  { code: "+974", country: "Qatar", maxLength: 8 },
  { code: "+975", country: "Bhutan", maxLength: 8 },
  { code: "+976", country: "Mongolia", maxLength: 8 },
  { code: "+977", country: "Nepal", maxLength: 10 },
];

exports.carMakes2 = [
  "Abarth",
  "Acura",
  "Alfa Romeo",
  "Aston Martin",
  "Audi",
  "Bentley",
  "BMW",
  "Bugatti",
  "Buick",
  "Cadillac",
  "Changan",
  "Chery",
  "Chevrolet",
  "Chrysler",
  "Citroën",
  "Dacia",
  "Daewoo",
  "Daihatsu",
  "Datsun",
  "Dodge",
  "DS Automobiles",
  "Ferrari",
  "Fiat",
  "Ford",
  "Geely",
  "Genesis",
  "GMC",
  "Honda",
  "Hyundai",
  "Infiniti",
  "Isuzu",
  "Jaguar",
  "Jeep",
  "Kia",
  "Koenigsegg",
  "Lada",
  "Lamborghini",
  "Lancia",
  "Land Rover",
  "Lexus",
  "Lincoln",
  "Lotus",
  "Mahindra",
  "Maruti Suzuki",
  "Maserati",
  "Maxus",
  "Mazda",
  "McLaren",
  "Mercedes-Benz",
  "MG",
  "Mini",
  "Mitsubishi",
  "Morgan",
  "Morris",
  "Nio",
  "Nissan",
  "Opel",
  "Pagani",
  "Peugeot",
  "Polestar",
  "Porsche",
  "Proton",
  "Ram",
  "Renault",
  "Rivian",
  "Rolls-Royce",
  "Saab",
  "Seat",
  "Skoda",
  "Smart",
  "SsangYong",
  "Subaru",
  "Suzuki",
  "Tata",
  "Tesla",
  "Toyota",
  "Vauxhall",
  "Volkswagen",
  "Volvo",
  "Wuling",
  "Xpeng",
  "Zeekr",
];

exports.states = [
  // States
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",

  // Union Territories
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];
exports.locations = [
  "24 Parganas",
  "Adilabad",
  "Agra",
  "Ahmedabad",
  "Ahmednagar",
  "Aizawl",
  "Ajitgarh (Mohali)",
  "Ajmer",
  "Akola",
  "Alappuzha",
  "Aligarh",
  "Alirajpur",
  "Allahabad",
  "Almora",
  "Alwar",
  "Ambala",
  "Ambedkar Nagar",
  "Amravati",
  "Amreli district",
  "Amritsar",
  "Anand",
  "Anantapur",
  "Anantnag",
  "Angul",
  "Anjaw",
  "Anuppur",
  "Araria",
  "Ariyalur",
  "Arwal",
  "Ashok Nagar",
  "Auraiya",
  "Aurangabad",
  "Azamgarh",
  "Badgam",
  "Bagalkot",
  "Bageshwar",
  "Bagpat",
  "Bahraich",
  "Baksa",
  "Balaghat",
  "Balangir",
  "Balasore",
  "Ballia",
  "Balrampur",
  "Banaskantha",
  "Banda",
  "Bandipora",
  "Bangalore",
  "Banka",
  "Bankura",
  "Banswara",
  "Barabanki",
  "Baramulla",
  "Baran",
  "Bardhaman",
  "Bareilly",
  "Bargarh (Baragarh)",
  "Barmer",
  "Barnala",
  "Barpeta",
  "Barwani",
  "Bastar",
  "Basti",
  "Bathinda",
  "Beed",
  "Begusarai",
  "Belgaum",
  "Bellary",
  "Betul",
  "Bhadrak",
  "Bhagalpur",
  "Bhandara",
  "Bharatpur",
  "Bharuch",
  "Bhavnagar",
  "Bhilwara",
  "Bhind",
  "Bhiwani",
  "Bhojpur",
  "Bhopal",
  "Bidar",
  "Bijapur",
  "Bijnor",
  "Bikaner",
  "Bilaspur",
  "Birbhum",
  "Bishnupur",
  "Bokaro",
  "Bongaigaon",
  "Boudh (Bauda)",
  "Budaun",
  "Bulandshahr",
  "Buldhana",
  "Bundi",
  "Burhanpur",
  "Buxar",
  "Cachar",
  "Central Delhi",
  "Chamarajnagar",
  "Chamba",
  "Chamoli",
  "Champaran",
  "Champawat",
  "Champhai",
  "Chandauli",
  "Chandel",
  "Chandigarh",
  "Chandrapur",
  "Changlang",
  "Chatra",
  "Chennai",
  "Chhatarpur",
  "Chhatrapati Shahuji Maharaj Nagar",
  "Chhindwara",
  "Chikkaballapur",
  "Chikkamagaluru",
  "Chirang",
  "Chitradurga",
  "Chitrakoot",
  "Chittoor",
  "Chittorgarh",
  "Churachandpur",
  "Churu",
  "Coimbatore",
  "Cooch Behar",
  "Cuddalore",
  "Cuttack",
  "Dadra and Nagar Haveli",
  "Dahod",
  "Dakshin Dinajpur",
  "Dakshina Kannada",
  "Daman",
  "Damoh",
  "Dantewada",
  "Darbhanga",
  "Darjeeling",
  "Darrang",
  "Datia",
  "Dausa",
  "Davanagere",
  "Debagarh (Deogarh)",
  "Dehradun",
  "Delhi",
  "Deoghar",
  "Deoria",
  "Dewas",
  "Dhalai",
  "Dhamtari",
  "Dhanbad",
  "Dhar",
  "Dharmapuri",
  "Dharwad",
  "Dhemaji",
  "Dhenkanal",
  "Dholpur",
  "Dhubri",
  "Dhule",
  "Dibang Valley",
  "Dibrugarh",
  "Dima Hasao",
  "Dimapur",
  "Dindigul",
  "Dindori",
  "Diu",
  "Doda",
  "Dumka",
  "Dungapur",
  "Durg",
  "Eluru",
  "Ernakulam",
  "Erode",
  "Etah",
  "Etawah",
  "Faizabad",
  "Faridabad",
  "Faridkot",
  "Farrukhabad",
  "Fatehabad",
  "Fatehgarh Sahib",
  "Fatehpur",
  "Fazilka",
  "Firozabad",
  "Firozpur",
  "Gadag",
  "Gadchiroli",
  "Gajapati",
  "Ganderbal",
  "Gandhinagar",
  "Ganganagar",
  "Ganjam",
  "Garhwa",
  "Garo Hills",
  "Gautam Buddh Nagar",
  "Gaya",
  "Ghaziabad",
  "Ghazipur",
  "Giridih",
  "Goa",
  "Goalpara",
  "Godda",
  "Golaghat",
  "Gonda",
  "Gondia",
  "Gopalganj",
  "Gorakhpur",
  "Gulbarga",
  "Gumla",
  "Guna",
  "Guntur",
  "Gurdaspur",
  "Gurgaon",
  "Gwalior",
  "Hailakandi",
  "Hamirpur",
  "Hanumangarh",
  "Harda",
  "Hardoi",
  "Haridwar",
  "Hassan",
  "Haveri district",
  "Hazaribag",
  "Hingoli",
  "Hissar",
  "Hooghly",
  "Hoshangabad",
  "Hoshiarpur",
  "Howrah",
  "Hyderabad",
  "Idukki",
  "Imphal",
  "Indore",
  "Jabalpur",
  "Jagatsinghpur",
  "Jaintia Hills",
  "Jaipur",
  "Jaisalmer",
  "Jajpur",
  "Jalandhar",
  "Jalaun",
  "Jalgaon",
  "Jalna",
  "Jalore",
  "Jalpaiguri",
  "Jammu",
  "Jamnagar",
  "Jamtara",
  "Jamui",
  "Janjgir-Champa",
  "Jashpur",
  "Jaunpur district",
  "Jehanabad",
  "Jhabua",
  "Jhajjar",
  "Jhalawar",
  "Jhansi",
  "Jharsuguda",
  "Jhunjhunu",
  "Jind",
  "Jodhpur",
  "Jorhat",
  "Junagadh",
  "Jyotiba Phule Nagar",
  "Kabirdham (Kawardha)",
  "Kadapa",
  "Kaimur",
  "Kaithal",
  "Kakinada",
  "Kalahandi",
  "Kameng",
  "Kamrup",
  "Kamrup Metropolitan",
  "Kanchipuram",
  "Kandhamal",
  "Kangra",
  "Kanker",
  "Kannauj",
  "Kannur",
  "Kanpur",
  "Kanshi Ram Nagar",
  "Kanyakumari",
  "Kapurthala",
  "Karaikal",
  "Karauli",
  "Karbi Anglong",
  "Kargil",
  "Karimganj",
  "Karimnagar",
  "Karnal",
  "Karur",
  "Kasaragod",
  "Kathua",
  "Katihar",
  "Katni",
  "Kaushambi",
  "Kendrapara",
  "Kendujhar (Keonjhar)",
  "Khagaria",
  "Khammam",
  "Khandwa",
  "Khargone",
  "Khasi Hills",
  "Kheda",
  "Khordha",
  "Khowai",
  "Khunti",
  "Kinnaur",
  "Kishanganj",
  "Kishtwar",
  "Kodagu",
  "Koderma",
  "Kohima",
  "Kokrajhar",
  "Kolar",
  "Kolasib",
  "Kolhapur",
  "Kolkata",
  "Kollam",
  "Koppal",
  "Koraput",
  "Korba",
  "Koriya",
  "Kota",
  "Kottayam",
  "Kozhikode",
  "Krishna",
  "Kulgam",
  "Kullu",
  "Kupwara",
  "Kurnool",
  "Kurukshetra",
  "Kurung Kumey",
  "Kushinagar",
  "Kutch",
  "Lahaul and Spiti",
  "Lakhimpur",
  "Lakhimpur Kheri",
  "Lakhisarai",
  "Lalitpur",
  "Latehar",
  "Latur",
  "Lawngtlai",
  "Leh",
  "Lohardaga",
  "Lohit",
  "Lower Dibang Valley",
  "Lower Subansiri",
  "Lucknow",
  "Ludhiana",
  "Lunglei",
  "Madhepura",
  "Madhubani",
  "Madurai",
  "Mahamaya Nagar",
  "Maharajganj",
  "Mahasamund",
  "Mahbubnagar",
  "Mahe",
  "Mahendragarh",
  "Mahoba",
  "Mainpuri",
  "Malappuram",
  "Maldah",
  "Malkangiri",
  "Mamit",
  "Mandi",
  "Mandla",
  "Mandsaur",
  "Mandya",
  "Mansa",
  "Marigaon",
  "Mathura",
  "Mau",
  "Mayurbhanj",
  "Medak",
  "Meerut",
  "Mehsana",
  "Mewat",
  "Mirzapur",
  "Moga",
  "Mokokchung",
  "Mon",
  "Moradabad",
  "Morena",
  "Mumbai",
  "Munger",
  "Murshidabad",
  "Muzaffarnagar",
  "Muzaffarpur",
  "Mysore",
  "Nabarangpur",
  "Nadia",
  "Nagaon",
  "Nagapattinam",
  "Nagaur",
  "Nagpur",
  "Nainital",
  "Nalanda",
  "Nalbari",
  "Nalgonda",
  "Namakkal",
  "Nanded",
  "Nandurbar",
  "Narayanpur",
  "Narmada",
  "Narsinghpur",
  "Nashik",
  "Navsari",
  "Nawada",
  "Nawanshahr",
  "Nayagarh",
  "Neemuch",
  "Nellore",
  "New Delhi",
  "Nilgiris",
  "Nizamabad",
  "Nuapada",
  "Ongole",
  "Osmanabad",
  "Pakur",
  "Palakkad",
  "Palamu",
  "Pali",
  "Palwal",
  "Panchkula",
  "Panchmahal",
  "Panchsheel Nagar district (Hapur)",
  "Panipat",
  "Panna",
  "Papum Pare",
  "Parbhani",
  "Paschim Medinipur",
  "Patan",
  "Pathanamthitta",
  "Pathankot",
  "Patiala",
  "Patna",
  "Pauri Garhwal",
  "Perambalur",
  "Phek",
  "Pilibhit",
  "Pimpri-Chinchwad",
  "Pithoragarh",
  "Pondicherry",
  "Poonch",
  "Porbandar",
  "Pratapgarh",
  "Pudukkottai",
  "Pulwama",
  "Pune",
  "Purba Medinipur",
  "Puri",
  "Purnia",
  "Purulia",
  "Raebareli",
  "Raichur",
  "Raigad",
  "Raigarh",
  "Raipur",
  "Raisen",
  "Rajauri",
  "Rajgarh",
  "Rajkot",
  "Rajnandgaon",
  "Rajsamand",
  "Ramabai Nagar (Kanpur Dehat)",
  "Ramanagara",
  "Ramanathapuram",
  "Ramban",
  "Ramgarh",
  "Rampur",
  "Ranchi",
  "Ratlam",
  "Ratnagiri",
  "Rayagada",
  "Reasi",
  "Rewa",
  "Rewari",
  "Ri Bhoi",
  "Rohtak",
  "Rohtas",
  "Rudraprayag",
  "Rupnagar",
  "Sabarkantha",
  "Sagar",
  "Saharanpur",
  "Saharsa",
  "Sahibganj",
  "Saiha",
  "Salem",
  "Samastipur",
  "Samba",
  "Sambalpur",
  "Sangli",
  "Sangrur",
  "Sant Kabir Nagar",
  "Sant Ravidas Nagar",
  "Saran",
  "Satara",
  "Satna",
  "Sawai Madhopur",
  "Sehore",
  "Senapati",
  "Seoni",
  "Seraikela Kharsawan",
  "Serchhip",
  "Shahdol",
  "Shahjahanpur",
  "Shajapur",
  "Shamli",
  "Sheikhpura",
  "Sheohar",
  "Sheopur",
  "Shimla",
  "Shimoga",
  "Shivpuri",
  "Shopian",
  "Shravasti",
  "Siang",
  "Sibsagar",
  "Siddharthnagar",
  "Sidhi",
  "Sikar",
  "Sikkim",
  "Simdega",
  "Sindhudurg",
  "Singhbhum",
  "Singrauli",
  "Sirmaur",
  "Sirohi",
  "Sirsa",
  "Sitamarhi",
  "Sitapur",
  "Sivaganga",
  "Siwan",
  "Solan",
  "Solapur",
  "Sonbhadra",
  "Sonipat",
  "Sonitpur",
  "Sri Muktsar Sahib",
  "Srikakulam",
  "Srinagar",
  "Subarnapur (Sonepur)",
  "Sultanpur",
  "Sundergarh",
  "Supaul",
  "Surat",
  "Surendranagar",
  "Surguja",
  "Tamenglong",
  "Tarn Taran",
  "Tawang",
  "Tehri Garhwal",
  "Thane",
  "Thanjavur",
  "The Dangs",
  "Theni",
  "Thiruvananthapuram",
  "Thoothukudi",
  "Thoubal",
  "Thrissur",
  "Tikamgarh",
  "Tinsukia",
  "Tirap",
  "Tiruchirappalli",
  "Tirunelveli",
  "Tirupur",
  "Tiruvallur",
  "Tiruvannamalai",
  "Tiruvarur",
  "Tonk",
  "Tripura",
  "Tuensang",
  "Tumkur",
  "Udaipur",
  "Udalguri",
  "Udham Singh Nagar",
  "Udhampur",
  "Udupi",
  "Ujjain",
  "Ukhrul",
  "Umaria",
  "Una",
  "Unnao",
  "Upper Subansiri",
  "Uttar Dinajpur",
  "Uttara Kannada",
  "Uttarkashi",
  "Vadodara",
  "Vaishali",
  "Valsad",
  "Varanasi",
  "Vellore",
  "Vidisha",
  "Viluppuram",
  "Virudhunagar",
  "Visakhapatnam",
  "Vizianagaram",
  "Vyara",
  "Warangal",
  "Wardha",
  "Washim",
  "Wayanad",
  "Wokha",
  "Yadgir",
  "Yamuna Nagar",
  "Yanam",
  "Yavatmal",
  "Zunheboto",
];

exports.carMakes = [
  "Abarth",
  "Acura",
  "Alfa Romeo",
  "Allstate",
  "Alpina",
  "Alpine",
  "AMG",
  "Apollo",
  "Artega",
  "Ascort",
  "Aston Martin",
  "Atlas",
  "Audi",
  "Austin",
  "Austin-Healey",
  "Autozam",
  "Avanti",
  "Bentley",
  "Berkeley",
  "Bizzarini",
  "BMW",
  "Bristol",
  "Bugatti",
  "Buick",
  "Cadillac",
  "Chevrolet",
  "Chrysler",
  "Citroen",
  "Contender",
  "Continental",
  "Cupra",
  "Daewoo",
  "Daihatsu",
  "Datsun",
  "Delta",
  "Diva",
  "DKW",
  "Dodge",
  "Elva",
  "Eucort",
  "Evante",
  "Felber",
  "Ferrari",
  "Fiat",
  "Fisker",
  "Flajole",
  "Ford",
  "Genesis",
  "Ghia",
  "GMC",
  "Hennessey",
  "Hillman",
  "Hindustan",
  "Honda",
  "Hudson",
  "Hummer",
  "Hyundai",
  "Imperia",
  "Imperial",
  "Infiniti",
  "Isuzu",
  "Itala",
  "Jaguar",
  "Jeep",
  "Kia",
  "Koenigsegg",
  "KTM",
  "Lambert",
  "Lamborghini",
  "Lancia",
  "Land-Rover",
  "Lexus",
  "Leyland",
  "Lincoln",
  "Lloyd",
  "Lotus",
  "Lucid",
  "Lynx",
  "Magenta",
  "Mahindra",
  "Maruti",
  "Maruti Suzuki",
  "Maserati",
  "Mastretta",
  "Mazda",
  "McLaren",
  "Mercedes-Benz",
  "MG",
  "Mini",
  "Mitsubishi",
  "Miura",
  "Monte Carlo",
  "Morris",
  "Nissan",
  "Nobel",
  "Noble",
  "Nova",
  "Opel",
  "Packard",
  "Pagani",
  "Panhard",
  "Peugeot",
  "Pininfarina",
  "Plymouth",
  "Polestar",
  "Polski Fiat",
  "Pontiac",
  "Porsche",
  "Premier",
  "Proton",
  "Ram",
  "Ranger",
  "Renault",
  "Rimac",
  "Rivian",
  "Rolls-Royce",
  "Ruf",
  "Saab",
  "Saleen",
  "San",
  "Scion",
  "Seat",
  "Shelby",
  "Singer",
  "Skoda",
  "Smart",
  "Ssangyong",
  "Standard",
  "Sterling",
  "Subaru",
  "Suzuki",
  "Tata",
  "Tesla",
  "Toyota",
  "Triumph",
  "Tucker",
  "Vauxhall",
  "Venturi",
  "Volkswagen",
  "Volvo",
  "Willam",
  "Willys",
  "Yak",
  "Zagato",
  "Zimmer",
];

exports.carModels = [
  "1000",
  "118NE",
  "3000GT",
  "325i",
  "370Z",
  "500",
  "520d",
  "525d",
  "530d",
  "595 Competizione",
  "645i",
  "650i",
  "718 Boxster",
  "718 Cayman",
  "720S",
  "735iL",
  "765LT",
  "800",
  "911",
  "A-Star",
  "A3",
  "A4",
  "A5",
  "A6",
  "A7",
  "A8",
  "Abarth Punto",
  "Accent",
  "Accord",
  "Alphard",
  "Alto",
  "Alto 800",
  "Alto K10",
  "Altroz",
  "Altroz EV",
  "Ameo",
  "Aria",
  "Arnage",
  "Aspire",
  "Astra",
  "Aventador",
  "Aveo U-VA",
  "Avinya",
  "Avventura",
  "Baleno",
  "Baleno Altura",
  "Baleno RS",
  "Beat",
  "Beetle",
  "Belta",
  "Bentayga",
  "Bolt",
  "Boxster",
  "BR-V",
  "Brezza",
  "Brio",
  "C40 Recharge",
  "Camaro",
  "Camry",
  "Captiva",
  "Captur",
  "Caraville",
  "Carens",
  "Carnival",
  "Carrera GT",
  "Cayenne",
  "Cayman",
  "Cedia",
  "Celerio",
  "Celerio X",
  "Centenario",
  "Ceres",
  "Challenger",
  "Charger",
  "Chiron",
  "Ciaz",
  "City",
  "Civic",
  "CLK",
  "Clubman",
  "Commuter",
  "Compass",
  "Continental GT",
  "Corolla",
  "Corolla Altis",
  "Corona",
  "Corsa",
  "Corvette C1",
  "Corvette C2",
  "Corvette C3",
  "Corvette C4",
  "Corvette C5",
  "Corvette C6",
  "Corvette C7",
  "Corvette C8",
  "Countach",
  "Countryman",
  "CR-V",
  "CrossPolo",
  "Crown",
  "Cruze",
  "CT4",
  "CT5",
  "CT6",
  "CTS",
  "Cullinan",
  "Curvv",
  "Curvv EV",
  "Cynos",
  "D-MAX",
  "Defender",
  "Delica",
  "Deville",
  "Diablo",
  "Discovery",
  "Divo",
  "Durango",
  "Duster",
  "Dzire",
  "E-Type",
  "E280",
  "E30",
  "E350",
  "E36",
  "E46",
  "E92",
  "Ecosport",
  "Eeco",
  "Eight",
  "Elantra",
  "Eldorado",
  "Elevate",
  "Elroq",
  "Endeavour",
  "Enjoy",
  "Enyaq",
  "Ertiga",
  "ES 300h",
  "Escalade",
  "Escort",
  "Espada",
  "Estate",
  "Esteem",
  "Estilo",
  "Estima",
  "Etios",
  "Etios Cross",
  "Etios Liva",
  "EV6",
  "Evalia",
  "F-Pace",
  "F-Type",
  "Fabia",
  "Fiesta",
  "Figo",
  "FJ Cruiser",
  "Fluence",
  "Flying Spur",
  "Forester",
  "Fortuner",
  "Freelander",
  "Freestyle",
  "Fronx",
  "FTO",
  "Fusion",
  "Gallardo",
  "Gazel",
  "Getz",
  "Ghibli",
  "Ghost",
  "Glanza",
  "Go",
  "Go+",
  "Golf GTI",
  "Grand Chrokee",
  "Grand Vitara",
  "GranTurismo",
  "GT-R",
  "GTI",
  "Gypsy",
  "H1",
  "H2",
  "H3",
  "Harrier",
  "Harrier EV",
  "Herald",
  "Hexa",
  "Hi-Lander",
  "HiAce",
  "Hilux",
  "Hummer EV",
  "Huracan",
  "Hyryder",
  "i10",
  "i20",
  "i8",
  "Ignis",
  "Ikon",
  "Impala",
  "Indica",
  "Indica Vista",
  "Indigo",
  "Innova",
  "Innova Crysta",
  "Innova Hycross",
  "Invicto",
  "Ioniq 5",
  "Jazz",
  "Jetta",
  "Jimny",
  "Karoq",
  "Kicks",
  "Kiger",
  "Kingsway",
  "Kizashi",
  "Kodiaq",
  "Koleos",
  "Kona",
  "Kushaq",
  "Kwid",
  "Kylaq",
  "Lancer",
  "Lancer Evolution",
  "Land Cruiser",
  "Land Cruiser Prado",
  "Laura",
  "Levante",
  "Linea",
  "LM 350h",
  "Lodgy",
  "LS 400",
  "LS 430",
  "LS 460",
  "LX 450",
  "LX 470",
  "LX 500d",
  "LX 570",
  "LX 600",
  "Macan",
  "Magnite",
  "Majesta",
  "Manza",
  "Matiz",
  "MC20",
  "Meridian",
  "Micra",
  "Minor",
  "ML 350",
  "Mobilio",
  "Mondeo",
  "MR2",
  "mu-X",
  "Mulsanne",
  "Murcielago",
  "Mustang",
  "Nano",
  "Nexon EV",
  "NX 350h",
  "NX100",
  "Octavia",
  "Octavia Combi",
  "Omni",
  "Optra",
  "Outlander",
  "P1",
  "Padmini",
  "Pajero",
  "Pajero Mini",
  "Pajero Sport",
  "Palio",
  "Panamera",
  "Passat",
  "Patrol",
  "Phaeton",
  "Phantom",
  "Polo",
  "Premio",
  "Previa",
  "Prius",
  "Pulse",
  "Punch",
  "Punch EV",
  "Punto",
  "Q2",
  "Q3",
  "Q4",
  "Q5",
  "Q6",
  "Q7",
  "Q8",
  "Qualis",
  "Quattroporte",
  "R8",
  "Range Rover",
  "Range Rover Evoque",
  "Range Rover Sport",
  "Range Rover Velar",
  "Rapid",
  "RAV4",
  "redi-Go",
  "Revuelto",
  "Rexton",
  "Ritz",
  "RS3",
  "RS5",
  "RS6",
  "RS7",
  "RS8",
  "Rumion",
  "RX 350h",
  "RX 500h",
  "S-Cross",
  "S-Presso",
  "S2000",
  "S3",
  "s350",
  "S4",
  "S40",
  "S5",
  "S6",
  "S60",
  "S7",
  "S8",
  "S80",
  "S90",
  "Safari",
  "Safari EV",
  "Sail",
  "Santa Fe",
  "Santro",
  "SC 430",
  "Scala",
  "Seltos",
  "Senna",
  "Sera",
  "Siena",
  "Sierra",
  "Silver Spur",
  "Slavia",
  "SLK",
  "Sonata",
  "Sonet",
  "Spark",
  "Sprinter",
  "Starlet",
  "Stingray",
  "Storm",
  "Sumo",
  "Sunny",
  "Superb",
  "Swift",
  "Swift Dzire",
  "SX4",
  "Syros",
  "T-ROC",
  "Taigun",
  "Tavera",
  "Taycan",
  "Tayron",
  "Teana",
  "Temerario",
  "Tercel",
  "Terrano",
  "Thar",
  "Tiago",
  "Tiago EV",
  "Tigor",
  "Tigor JTP",
  "Tiguan",
  "Touareg",
  "Trailblazer",
  "Triber",
  "TT",
  "Tucson",
  "Tundra",
  "Uno",
  "Urban Cruiser",
  "Urus",
  "V-Cross",
  "V40",
  "V60",
  "V90",
  "Vectra",
  "Vellfire",
  "Veneno",
  "Vento",
  "Ventury",
  "Verna",
  "Versa",
  "Veyron",
  "Victoris",
  "Virtus",
  "Vitara Brezza",
  "W123",
  "W124",
  "W211",
  "Wagon R",
  "WR-V",
  "Wraith",
  "Wrangler",
  "X-Trail",
  "X1",
  "X2",
  "X3",
  "X4",
  "X5",
  "X6",
  "X7",
  "XC40",
  "XC40 Recharge",
  "XC60",
  "XC90",
  "XF",
  "XF R",
  "XJ",
  "XJ L",
  "XL6",
  "XM",
  "Yaris",
  "Yeti",
  "Z1",
  "Z3",
  "Z4",
  "Z8",
  "Zen",
  "Zen Carbon",
  "Zen Estilo",
  "Zen Steel",
  "Zest",
];

// Brand to Models mapping for search suggestions
exports.carMakeModels = {
  Abarth: ["500", "595 Competizione"],
  Audi: [
    "A3",
    "A4",
    "A5",
    "A6",
    "A7",
    "A8",
    "Q2",
    "Q3",
    "Q4",
    "Q5",
    "Q6",
    "Q7",
    "Q8",
    "R8",
    "RS3",
    "RS5",
    "RS6",
    "RS7",
    "RS8",
    "RSQ8",
    "S3",
    "S4",
    "S5",
    "S6",
    "S7",
    "S8",
    "TT",
  ],
  "Aston Martin": [
    "Vantage",
    "DB11",
    "DBS",
    "Rapide",
    "Valhalla",
    "Vanquish",
    "Valkyrie",
    "DBX",
    "DBX707",
    "DB12",
  ],
  Bentley: ["Arnage", "Bentayga", "Continental GT", "Flying Spur", "Mulsanne"],
  BMW: [
    "325i",
    "520d",
    "525d",
    "530d",
    "645i",
    "650i",
    "735iL",
    "E30",
    "E36",
    "E46",
    "E92",
    "i8",
    "X1",
    "X2",
    "X3",
    "X4",
    "X5",
    "X6",
    "X7",
    "XM",
    "Z1",
    "Z3",
    "Z4",
    "Z8",
  ],
  Bugatti: ["Chiron", "Divo", "Veyron"],
  Buick: [],
  Cadillac: ["CT4", "CT5", "CT6", "CTS", "Deville", "Eldorado", "Escalade"],
  Chevrolet: [
    "Aveo U-VA",
    "Beat",
    "Camaro",
    "Captiva",
    "Corvette C1",
    "Corvette C2",
    "Corvette C3",
    "Corvette C4",
    "Corvette C5",
    "Corvette C6",
    "Corvette C7",
    "Corvette C8",
    "Cruze",
    "Enjoy",
    "Optra",
    "Sail",
    "Spark",
    "Tavera",
    "Trailblazer",
  ],
  Chrysler: [],
  Citroen: [],
  Datsun: ["Go", "Go+", "redi-Go"],
  Dodge: ["Challenger", "Charger", "Durango", "Kingsway", "Ram"],
  Ferrari: ["F8", "SF90", "Roma", "Portofino", "812"],
  Fiat: [
    "500",
    "118NE",
    "Linea",
    "Palio",
    "Punto",
    "Siena",
    "Uno",
    "Avventura",
    "Abarth Punto"
  ],
  Ford: [
    "Aspire",
    "Ecosport",
    "Endeavour",
    "Escort",
    "Fiesta",
    "Figo",
    "Freestyle",
    "Fusion",
    "Ikon",
    "Mondeo",
    "Mustang",
  ],
  Genesis: [],
  GMC: ["Sierra", "H1", "H2", "H3", "Hummer EV"],
  Honda: [
    "Accord",
    "Amaze",
    "BR-V",
    "Brio",
    "City",
    "Civic",
    "CR-V",
    "Elevate",
    "Jazz",
    "Mobilio",
    "S2000",
    "WR-V",
  ],
  Hummer: ["H1", "H2", "H3", "Hummer EV"],
  Hyundai: [
    "Accent",
    "Alcazar",
    "Aura",
    "Creta",
    "Elantra",
    "Getz",
    "i10",
    "i20",
    "Ioniq 5",
    "Kona",
    "Santa Fe",
    "Santro",
    "Sonata",
    "Tucson",
    "Venue",
    "Verna",
  ],
  Infiniti: [],
  Isuzu: ["D-MAX", "mu-X", "V-Cross"],
  Jaguar: ["E-Type", "F-Pace", "F-Type", "XF", "XF R", "XJ", "XJ L"],
  Jeep: ["Compass", "Grand Cherokee", "Meridian", "Wrangler"],
  Kia: ["Carens", "Carnival", "EV6", "Seltos", "Sonet", "Syros"],
  Koenigsegg: ["Agera", "Jesko", "Regera"],
  Lamborghini: [
    "Aventador",
    "Centenario",
    "Countach",
    "Diablo",
    "Gallardo",
    "Huracan",
    "Murcielago",
    "Revuelto",
    "Temerario",
    "Urus",
    "Veneno",
    "Espada",
  ],
  "Land-Rover": [
    "Defender",
    "Discovery",
    "Freelander",
    "Range Rover",
    "Range Rover Evoque",
    "Range Rover Sport",
    "Range Rover Velar",
  ],
  "Land Rover": [
    "Defender",
    "Discovery",
    "Freelander",
    "Range Rover",
    "Range Rover Evoque",
    "Range Rover Sport",
    "Range Rover Velar",
  ],
  Lexus: [
    "ES 300h",
    "LM 350h",
    "LS 400",
    "LS 430",
    "LS 460",
    "LX 450",
    "LX 470",
    "LX 500d",
    "LX 570",
    "LX 600",
    "NX 350h",
    "RX 350h",
    "RX 500h",
    "SC 430",
  ],
  Lincoln: [],
  Lotus: ["Elise", "Evora", "Exige"],
  Lucid: ["Air"],
  Mahindra: [
    "Alturas G4",
    "Bolero",
    "KUV100",
    "Marazzo",
    "Scorpio",
    "Thar",
    "XUV300",
    "XUV500",
    "XUV700",
    "Xylo",
  ],
  Maruti: [
    "800",
    "1000",
    "A-Star",
    "Alto",
    "Alto 800",
    "Alto K10",
    "Baleno",
    "Baleno Altura",
    "Baleno RS",
    "Brezza",
    "Celerio",
    "Celerio X",
    "Ciaz",
    "Dzire",
    "Eeco",
    "Ertiga",
    "Esteem",
    "Estilo",
    "Fronx",
    "Grand Vitara",
    "Gypsy",
    "Ignis",
    "Invicto",
    "Jimny",
    "Omni",
    "Ritz",
    "S-Cross",
    "S-Presso",
    "Swift",
    "Swift Dzire",
    "SX4",
    "Wagon R",
    "XL6",
    "Zen",
    "Zen Carbon",
    "Zen Estilo",
    "Zen Steel",
  ],
  "Maruti Suzuki": [
    "800",
    "1000",
    "A-Star",
    "Alto",
    "Alto 800",
    "Alto K10",
    "Baleno",
    "Baleno Altura",
    "Baleno RS",
    "Brezza",
    "Celerio",
    "Celerio X",
    "Ciaz",
    "Dzire",
    "Eeco",
    "Ertiga",
    "Esteem",
    "Estilo",
    "Fronx",
    "Grand Vitara",
    "Gypsy",
    "Ignis",
    "Invicto",
    "Jimny",
    "Omni",
    "Ritz",
    "S-Cross",
    "S-Presso",
    "Swift",
    "Swift Dzire",
    "SX4",
    "Wagon R",
    "XL6",
    "Zen",
    "Zen Carbon",
    "Zen Estilo",
    "Zen Steel",
  ],
  Maserati: ["Ghibli", "GranTurismo", "Levante", "MC20", "Quattroporte"],
  Mazda: ["MX-5", "CX-5", "CX-9", "RX-7", "RX-8", "MR2", "FTO"],
  McLaren: ["720S", "765LT", "P1", "Senna"],
  "Mercedes-Benz": [
    "A-Class",
    "C-Class",
    "CLK",
    "E-Class",
    "E280",
    "E350",
    "G-Class",
    "GLA",
    "GLC",
    "GLE",
    "GLS",
    "Maybach",
    "ML 350",
    "S-Class",
    "SLK",
    "Sprinter",
    "W123",
    "W124",
    "W211",
  ],
  MG: ["Astor", "Comet", "Gloster", "Hector", "ZS EV"],
  Mini: ["Clubman", "Countryman", "Cooper"],
  Mitsubishi: [
    "3000GT",
    "Cedia",
    "Delica",
    "FTO",
    "Lancer",
    "Lancer Evolution",
    "Outlander",
    "Pajero",
    "Pajero Mini",
    "Pajero Sport",
  ],
  Morris: ["Minor", "Oxford", "Traveller"],
  Nissan: [
    "370Z",
    "Evalia",
    "GT-R",
    "Kicks",
    "Magnite",
    "Micra",
    "Patrol",
    "Sunny",
    "Teana",
    "Terrano",
    "X-Trail",
  ],
  Opel: ["Astra", "Corsa", "Vectra"],
  Pagani: ["Huayra", "Zonda"],
  Peugeot: [],
  Polestar: ["Polestar 2"],
  Porsche: [
    "718",
    "Boxster",
    "Cayman",
    "911",
    "Boxster",
    "Carrera GT",
    "Cayenne",
    "Macan",
    "Panamera",
    "Taycan",
  ],
  Renault: [
    "Captur",
    "Duster",
    "Fluence",
    "Kiger",
    "Koleos",
    "Kwid",
    "Lodgy",
    "Pulse",
    "Scala",
    "Triber",
  ],
  "Rolls-Royce": [
    "Cullinan",
    "Dawn",
    "Ghost",
    "Phantom",
    "Silver Spur",
    "Wraith",
  ],
  San: ["Storm"],
  Skoda: [
    "Elroq",
    "Enyaq",
    "Fabia",
    "Karoq",
    "Kodiaq",
    "Kushaq",
    "Kylaq",
    "Laura",
    "Octavia",
    "Octavia Combi",
    "Rapid",
    "Slavia",
    "Superb",
    "Yeti",
  ],
  Standard: ["Herald", "Gazel"],
  Subaru: ["Forester", "Impreza", "Outback", "WRX"],
  Suzuki: [
    "Alto",
    "Baleno",
    "Celerio",
    "Ciaz",
    "Dzire",
    "Ertiga",
    "Grand Vitara",
    "Ignis",
    "Jimny",
    "Kizashi",
    "S-Cross",
    "Swift",
    "SX4",
    "Wagon R",
    "XL6",
  ],
  Tata: [
    "Altroz",
    "Altroz EV",
    "Aria",
    "Bolt",
    "Curvv",
    "Curvv EV",
    "Estate",
    "Harrier",
    "Harrier EV",
    "Hexa",
    "Indica",
    "Indica Vista",
    "Indigo",
    "Manza",
    "Nano",
    "Nexon",
    "Nexon EV",
    "Punch",
    "Punch EV",
    "Safari",
    "Safari EV",
    "Sierra",
    "Sumo",
    "Tiago",
    "Tiago EV",
    "Tigor",
    "Tigor JTP",
    "Zest",
  ],
  Tesla: ["Model 3", "Model S", "Model X", "Model Y", "Cybertruck"],
  Toyota: [
    "Alphard",
    "Belta",
    "Camry",
    "Corolla",
    "Corolla Altis",
    "Corona",
    "Crown",
    "Cynos",
    "Estima",
    "Etios",
    "Etios Cross",
    "Etios Liva",
    "FJ Cruiser",
    "Fortuner",
    "Glanza",
    "HiAce",
    "Hilux",
    "Hyryder",
    "Innova",
    "Innova Crysta",
    "Innova Hycross",
    "Land Cruiser",
    "Land Cruiser Prado",
    "Majesta",
    "Premio",
    "Previa",
    "Prius",
    "Qualis",
    "RAV4",
    "Rumion",
    "Sera",
    "Starlet",
    "Tercel",
    "Tundra",
    "Urban Cruiser",
    "Vellfire",
    "Yaris",
  ],
  Volkswagen: [
    "Beetle",
    "CrossPolo",
    "Golf GTI",
    "GTI",
    "Jetta",
    "Passat",
    "Phaeton",
    "Polo",
    "T-ROC",
    "Taigun",
    "Tayron",
    "Tiguan",
    "Touareg",
    "Vento",
    "Virtus",
    "Ameo",
  ],
  Volvo: [
    "C40 Recharge",
    "S40",
    "S60",
    "S80",
    "S90",
    "V40",
    "V60",
    "V90",
    "XC40",
    "XC40 Recharge",
    "XC60",
    "XC90",
  ],
};

function processCarModels(input) {
  const lines = input.map((line) => line.trim()).filter((line) => line !== "");

  // Remove duplicates (case-insensitive) and sort alphabetically
  const unique = [...new Set(lines)];
  unique.sort((a, b) => a.localeCompare(b));

  // Print in array form
  // console.log(JSON.stringify(unique, null, 2));

  return unique;
}

// console.log(processCarModels(this.carModels));
//this prints all the elements no matter the size of array:
// console.dir(processCarModels(this.locations), {
//   depth: null,
//   maxArrayLength: null,
// });
